<template lang="pug">
    .component.component-backoffice-reporting.reporting.card(v-if="item")
        .inner-content(v-if="$is('listing')")
            card7(:showBullets="true", :showAction="true")
                div(slot="actionBullets")
                    dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                        reporting-action-buttons(:reporting="item")
                reporting-fields(slot="n1", :item="item", :fieldName="'reporting-id'")
                reporting-fields(slot="n1", :item="item", :fieldName="'reporting-name'")
                reporting-fields(slot="n2", :item="item", :fieldName="'reporting-driver-info'")
                reporting-fields(slot="n3", :item="item", :fieldName="'reporting-location'")
                reporting-fields(slot="n4", :item="item", :fieldName="'reporting-vehicle'")
                reporting-fields(slot="n5", :item="item", :fieldName="'reporting-reported-at'")
                reporting-fields(slot="n6", :item="item", :fieldName="'reporting-updated-at'")
                reporting-fields(slot="n7", :item="item", :fieldName="'reporting-status'")


                div(slot="actionPage")
                    router-link(:to="{name:'reporting',params:{id:item.id}}")
                        i.fa.fa-angle-right.fa-3x.action
</template>
<script type="text/babel">
    import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
    import Accordion from '../../components/structure/foundation/Accordion'
    import MaggieHelper from "../../maggieHelper";
    import Driver from 'components/backoffice/Driver'
    import Vehicle from 'components/backoffice/Vehicle'
    import Card7 from "../structure/Card7";
    import Status from "../structure/ui/Status";
    import Dropdown from "../structure/foundation/Dropdown";
    import ReportingActionButtons from "../structure/ui/actions/ReportingActionButtons";
    import ReportingFields from "../structure/ui/entity-fields/ReportingFields.vue";

    export default{
        name: "Reporting",
        components: {
            ReportingFields,
            ReportingActionButtons,
            Dropdown,
            Status,
            Card7,
            Vehicle,
            Driver,
            Accordion,
            KeplerBackofficeSdk,
            MaggieHelper
        },
        data(){
            return {}
        },
        created() {
        },
        methods: {
        },
        props: {
            item: Object,
            type: {
                type: String,
                default: ''
            }
        },
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// Reporting.vue?cca47e92